import {
  LOG_PREFIX,
  allTemplates,
  copyMap,
  BUILD_TIMESTAMP,
} from '../resources';

export const log = (...data: unknown[]) => {
  // put sessionStorage.setItem("Bookmarking-logging", "true") in console to enable logging on prod.
  if (
    isAcceptance ||
    sessionStorage.getItem('Bookmarking-logging') === 'true'
  ) {
    console.log(LOG_PREFIX, ...data);
  }
};

export const isAcceptance =
  location.origin.includes('acc') || location.origin.includes('localhost');

export const appendFile = (file: string) => {
  const accHref = `https://sel-static.acc.persgroep.net/bookmarking/deploys/${encodeURIComponent(
    BUILD_TIMESTAMP
  )}/${file}`;
  const prodHref = `https://sel-static.persgroep.net/bookmarking/deploys/${encodeURIComponent(
    BUILD_TIMESTAMP
  )}/${file}`;
  const link = document.createElement('link');
  link.href = isAcceptance ? accHref : prodHref;
  link.rel = 'stylesheet';
  document.body.appendChild(link);
};

export const getCopy = (brandName: BrandName, ...args: string[]): string => {
  const value = getNestedValueByArgs(copyMap[brandName], ...args);
  const valueType = typeof value;
  if (valueType !== 'string') {
    console.error(
      LOG_PREFIX + `expected string, got ${valueType} with value ${value}`
    );
    return '';
  }
  return value;
};
// Returns a template populated with copy.
// important is that the shape of both object is the same.
export const getTemplate = (brandName: BrandName, ...args: string[]) => {
  //get copy
  const copy: TemplateCopyItem = getNestedValueByArgs(
    copyMap[brandName],
    ...args
  );
  // use copy in provided template
  return getNestedValueByArgs(allTemplates(copy), ...args);
};

// example: if the object is:
// const myObject = { a: { b: { c: { some: "value" } } } }
// getNestedValueByArgs(myObject, 'a', 'b', 'c' ) would return object c which is { some: "value" }
// we do it this way because we need to reuse the object location in the form of args in 2 places, templates and copy.
export const getNestedValueByArgs = (srcObj: object, ...args: string[]) => {
  let current = { ...srcObj };
  args.forEach((arg) => {
    if (!args.length) {
      return;
    } else {
      if (!current)
        console.error(LOG_PREFIX + ` could not find ${arg} in ${srcObj}`);
      current = current[arg];
    }
  });
  return current;
};
